import PartnerRow from './PartnerRow';

const PartnerTable = ({ partners, onView, onEdit, onFreeze, onDelete }) => {
  return (
    <div className="hidden md:block overflow-x-auto w-full min-h-[300px] pb-12">
      <div className="min-w-full">
        {/* Table Header */}
        <div className="flex bg-white border-b border-slate-100 text-xs font-bold text-slate-400 items-center">
          <div className="w-16 sm:w-20 px-6 py-3.5 whitespace-nowrap text-slate-400">Sr no.</div>
          <div className="flex-1 min-w-[180px] px-6 py-3.5">Partner</div>
          <div className="w-32 sm:w-36 px-6 py-3.5">Type</div>
          <div className="w-36 sm:w-44 px-6 py-3.5">Phone Number</div>
          <div className="w-28 sm:w-32 px-6 py-3.5 text-center">Status</div>
          <div className="w-28 sm:w-32 px-4 py-3.5 text-center">Actions</div>
        </div>

        {/* Rows */}
        <div className="divide-y divide-slate-100">
          {partners.map((partner, index) => (
            <PartnerRow
              key={partner._id}
              partner={partner}
              index={index}
              onView={onView}
              onEdit={onEdit}
              onFreeze={onFreeze}
              onDelete={onDelete}
            />
          ))}
        </div>
      </div>
    </div>
  );
};

export default PartnerTable;
